/**
 * Please see `docs/architectures/core.md`
 */
export enum AlertStatus {
  TOKEN_ERROR = 200,
  UPLOAD_FOLDER_FULL = 201,
  SAVING_FAILED = 202,
  NO_AUTHED = 203,
  RECAPTCHA_FAILED = 204,
  MISSED_ANSWER = 205,
  INVALID_PARAMS = 206
}
